export var videoStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      display: 'inline-block',
      verticalAlign: 'middle',
      width: v.width,
      height: v.height || 'auto'
    };
  }
};